import PersonaSurveyModalComponent from './persona-survey-modal.component'

const PersonaSurveyModalModule = angular.module('cdbl.persona-survey-modal', [

])
  .component('cdblPersonaSurveyModal', PersonaSurveyModalComponent)
  .name

export default PersonaSurveyModalModule
